import { render, staticRenderFns } from "./ButtonSelect.vue?vue&type=template&id=00a2089a&scoped=true"
import script from "./ButtonSelect.vue?vue&type=script&lang=js"
export * from "./ButtonSelect.vue?vue&type=script&lang=js"
import style0 from "./ButtonSelect.vue?vue&type=style&index=0&id=00a2089a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a2089a",
  null
  
)

export default component.exports